module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASUAAAGXAQMAAADPq9RKAAAAAXNSR0IArs4c6QAAAANQTFRF4jY2S7o9+AAAAAF0Uk5TPRiOlHcAAAAlSURBVBgZ7cEBAQAAAIKg/q92SMAAAAAAAAAAAAAAAAAAAIBDATxqAAFYg9wcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/userbj2.png
// module id = tSfP
// module chunks = 2